import CustomReports from '../components/CustomReport';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Footer from '../components/common/Footer';

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-[url('/background.png')] bg-cover inset-0 bg-[rgba(15,21,37,0.8)] z-[-1]">
      <div className="mx-auto">
        <Navbar />
        <div className="flex">
          <Sidebar/>
          <main className="flex-1 p-4 pb-32 md:ml-6 overflow-x-auto min-w-0 bg-white md:rounded-l-lg">
            <CustomReports />
          </main>
        </div>
        <Footer/>
      </div>
    </div>
  );
}
